import { Navigate } from 'react-router-dom';
import { getToken } from '@/utils';
function AuthRoute({ children }: { children: React.ReactNode }) {
  const tokenStr = getToken();
  if (tokenStr) {
    return <>{children}</>;
  } else {
    return <Navigate to='/login' replace />;
  }
}

export { AuthRoute };
